import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MultiSourceTab from '../../../../Components-2025/IR/MultiSourceTab';
import { apiServices } from './apiServerProvider';
import { messages } from '../../../../common/messages';
import AppRoutes from '../../../config/AppRoutes';
import { EXAM_NAMES, examNameAccordingToDB, QUESTION_TYPE, TABLE_NAME } from '../../../../common/constant';

class GMATTab extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {};
  }

  redirectTo = (path) => {
    const { router } = this.context;
    const { chapterid, readingid, subscription, reading } = this.props.params;

    const routes = {
      question: AppRoutes.VIEW_EA_QUESTION.replace(':chapter_no', chapterid)
        .replace(':id', readingid)
        .replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free')
        .replace(':reading', reading),

      reading: AppRoutes.EA_READING.replace(':id', chapterid),
    };

    if (routes[path]) {
      router.push({ pathname: routes[path] });
    }
  };
  handleChangeParams = (value) => {
    const { index, question_id } = value;
    const { chapterid, readingid, subscription, reading } = this.props.params;
    this.context.router.push({
      pathname: AppRoutes.EA_TAB.replace(':chapterid', chapterid)
        .replace(':readingid', readingid)
        .replace(':subscription', subscription)
        .replace(':question_id', question_id)
        .replace(':offset', index)
        .replace(':reading', reading),
    });
  };

  render() {
    return (
      <div>
        <MultiSourceTab
          {...this.props}
          apiServices={apiServices}
          examName={examNameAccordingToDB.EA}
          questionType={QUESTION_TYPE.TAB_QUESTION}
          stateTableName={TABLE_NAME.EA_QUESTION_STATS}
          questionMode={EXAM_NAMES.EA}
          redirectTo={this.redirectTo}
          handleChangeParams={this.handleChangeParams}
        />
      </div>
    );
  }
}
export default GMATTab;



// WEBPACK FOOTER //
// ./src/views/EA-Exams/QuestionBank/SpecialQuestions/Tab.js